/**
 * @namespace satd
 */
import { concatAll } from '~/utils/lib/core/prelude';

/** @enum {typeof TAB_MENU [keyof typeof TAB_MENU]} */
export const TAB_MENU = /** @const */ ({
  ACCOMPTES: 'accomptes',
  SAISIES: 'saisies',
})

export const getAccomptesRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe,
) => concatAll([
  `/data/${structure_id}`,
  `/satd`,
  `/accomptes`,
  `?company=${encodeURIComponent(code_societe)}`
])

export const getSaisiesRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe,
) => concatAll([
  `/data/${structure_id}`,
  `/satd`,
  `/saisies`,
  `?company=${encodeURIComponent(code_societe)}`
])

export const getSaisiesCreationRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe,
) => concatAll([
  `/data/${structure_id}`,
  `/satd`,
  `/saisies`,
  `/add`,
  `?company=${encodeURIComponent(code_societe)}`
])

export const getSaisiesDetailsRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe,
  /** @type {import('~/stores/satd/saisies/list').SaisieWithSalarie["saisie_id"]} */ saisie_id,
) => concatAll([
  `/data/${structure_id}`,
  `/satd`,
  `/saisies`,
  `/${saisie_id}`,
  `/details`,
  `?company=${encodeURIComponent(code_societe)}`
])

export const useStore_satd = defineStore('satd', {
  state: () => ({
    isPending: false,
    selectedTabMenu: TAB_MENU.SAISIES,
  }),
  getters: {
    lastNavigatedRoute: ({ selectedTabMenu }) => {
      switch (selectedTabMenu) {
        case TAB_MENU.ACCOMPTES:
          return getAccomptesRoute
        case TAB_MENU.SAISIES:
          return getSaisiesRoute
      }
    },
  },
  actions: {
    /// Mutations
    ///
    setTabItem(/** @type {TAB_MENU} */ value) {
      this.selectedTabMenu = value
    },
  }
})
